import React, { useEffect } from "react";
import Slider from "../components/slider/Slider";
import Categories from "../components/categories/Categories";
import PopularProduct from "../components/popularProduct/PopularProduct";
import RecentlyLaunched from "../components/recentlyLaunched/RecentlyLaunched";
import AllProducts from "../components/allProducts/AllProducts";

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#f2f2f23b]">
      <div className="min-h-screen">
        <div className="bg-grey-50 ">
          <div className="mx-auto ">
            <div className="flex w-full">
              <div className="lg:block w-full lg:w-5/5 ">
                <Slider />
              </div>
            </div>
          </div>
        </div>

        <Categories />
        <RecentlyLaunched />
        <PopularProduct />
        <AllProducts />
      </div>
    </div>
  );
}

export default Home;
